import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-scheme-preview',
    templateUrl: './scheme-preview.component.html',
    styleUrls: ['./scheme-preview.component.scss'],
})
export class SchemePreviewComponent {
    @Input()
    public primaryScheme: string;

    constructor() {}

    public schemeDownloadUrl(schemeId: string, preview?: boolean) {
        return `${environment.http.baseUrl}quote/schema/${schemeId}` + (preview ? '?preview=true' : '');
    }
}
